import { render } from "./organisation.html?vue&type=template&id=2287d126&external"
import script from "./organisation.js?vue&type=script&lang=js&external"
export * from "./organisation.js?vue&type=script&lang=js&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__